import { api } from './client';
import type { LoteSVG, ProyectoCode } from '../types/sitePlan';

/**
 * Trae todos los lotes de un proyecto desde el endpoint del Function App.
 * Con ~413 lotes por proyecto la carga es instantánea — los filtros se aplican
 * en cliente con useMemo, sin roundtrips.
 */
export async function fetchLotesPorProyecto(
  proyecto: ProyectoCode,
  signal?: AbortSignal,
): Promise<LoteSVG[]> {
  return api.sitePlan.lotes(proyecto, signal);
}